var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "el-dialog",
        {
          staticClass: "articleModal",
          attrs: {
            visible: _vm.visible,
            title: "商户权限选择",
            top: "100px",
            width: "600px",
            "destroy-on-close": "",
            modal: false,
            "close-on-click-modal": false,
          },
          on: {
            "update:visible": function ($event) {
              _vm.visible = $event
            },
          },
        },
        [
          _c(
            "el-form",
            { ref: "pram" },
            [
              _c(
                "el-form-item",
                { attrs: { label: "角色权限", prop: "interfaceTemplate" } },
                [
                  _c(
                    "el-checkbox-group",
                    {
                      attrs: { size: "small" },
                      model: {
                        value: _vm.checkboxGroup,
                        callback: function ($$v) {
                          _vm.checkboxGroup = $$v
                        },
                        expression: "checkboxGroup",
                      },
                    },
                    _vm._l(_vm.roteOption, function (item) {
                      return _c(
                        "el-checkbox",
                        { key: item.id, attrs: { label: item.id } },
                        [
                          _vm._v(
                            "\n            " +
                              _vm._s(item.roleName) +
                              "\n          "
                          ),
                        ]
                      )
                    }),
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c(
                "el-button",
                {
                  attrs: { type: "primary", loading: _vm.loading },
                  on: { click: _vm.handerSubmit },
                },
                [_vm._v("确认")]
              ),
              _vm._v(" "),
              _c(
                "el-button",
                { attrs: { type: "link" }, on: { click: _vm.closeEdit } },
                [_vm._v("关闭")]
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }